import Conversations from '@twilio/conversations';
import { appointmentsService } from '../_services';

const state = {
  client: {},
  conversation: {},
  messages: [],
  token: '',
  conversation_sid: '',
  loading: false,
  task: {},
  lastReadMessage: 0,
  unreadMessageCount: null,
};

const actions = {
  async performTask({ commit }, task) {
    commit('updateTask', task);
  },
  async getToken({ commit }, { appointmentId, username }) {
    const response = await appointmentsService.joinChatRoom(appointmentId, username);
    commit('updateToken', response.data.token);
    commit('updateConversationSid', response.data.csid);
  },
  async getClient({ commit }, token) {
    const client = await Conversations.create(token);
    commit('updateClient', client);
  },
  async joinChatRoom({ commit, state, dispatch }, { appointmentId, username }) {
    commit('updateLoading', true);
    await dispatch('getToken', { appointmentId, username });
    await dispatch('getClient', state.token);
    await dispatch('getConversation');
    await dispatch('getMessages');
    await dispatch('setMessageListener');
    commit('updateLoading', false);
  },
  async getConversation({ state, commit }) {
    const conv = await state.client.getConversationBySid(state.conversation_sid);
    commit('updateConversation', conv);
  },
  async getMessages({ state, commit }) {
    const msgs = await state.conversation.getMessages();
    commit('updateMessages', msgs);
  },
  async setAllMessagesAsRead({ state, commit, dispatch }) {
    await state.conversation.setAllMessagesRead();
    dispatch('getUnreadMessagesCount');
  },
  async getUnreadMessagesCount({ state, commit }) {
    const count = await state.conversation.getUnreadMessagesCount();
    console.log('message count = ', count);
    commit('updateUnreadMessageCount', count || 0);
  },
  async sendMessage({ state }, { message, attributes }) {
    await state.conversation.sendMessage(message, attributes);
  },
  setMessageListener({ state, dispatch }) {
    state.conversation.on('messageAdded', (data) => {
      if (data.state.attributes.type === 'system') {
        dispatch('performTask', {
          action: data.state.attributes.action,
          payload: data.state.attributes.payload,
        });
      } else {
        dispatch('getMessages');
        dispatch('getUnreadMessagesCount');
      }
    });
  },
};

const mutations = {
  // A no-op mutation must be added to serve as a trigger for a reset.
  reset: () => { },
  updateUnreadMessageCount(state, count) {
    state.unreadMessageCount = count;
  },
  updateLastReadMessage(state, id) {
    state.lastReadMessage = id;
  },
  updateTask(state, task) {
    state.task = task;
  },
  updateLoading(state, status) {
    state.loading = status;
  },
  updateClient(state, client) {
    state.client = client;
  },
  updateToken(state, token) {
    state.token = token;
  },
  updateConversationSid(state, conversation_sid) {
    state.conversation_sid = conversation_sid;
  },
  updateConversation(state, conversation) {
    state.conversation = conversation;
  },
  updateMessages(state, messages) {
    state.messages = messages;
  },
};

const getters = {
  formattedMessages: (state) => state.messages?.items?.map((msg) => ({ author: msg.author, message: msg.body, attributes: msg.attributes })) ?? [],
};

export const chat = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
